/**
 * Test / internal account detection for analytics. Mirrors
 * server/utils/testAccounts.js: keep the two pattern lists in sync.
 *
 * Set as the `is_test_account` person property on identify, so PostHog's
 * "filter out internal and test users" setting can exclude QA, agent and
 * staff accounts from funnels and signup counts.
 */
export const TEST_ACCOUNT_PATTERNS: RegExp[] = [
  /@delphina\.money$/i,
  /@minithlabs\./i,
  /@example\.(com|org|net)$/i,
  /\.(test|invalid|local|localhost)$/i,
  /(^|[+._-])(test|testing|qa|e2e|playwright|cypress|nux|dogfood|seed)([+._-]|\d|@)/i,
  /\+(test|qa|e2e|demo)[^@]*@/i,
];

export function isTestAccountEmail(email?: string | null): boolean {
  if (!email || typeof email !== 'string') return false;
  return TEST_ACCOUNT_PATTERNS.some((p) => p.test(email.trim()));
}
